export default __webpack_public_path__ + "assets/c5eaf625985faa67d80d90055511d8e1.png";